export const NINETY_DAYS_MS = 90 * 24 * 60 * 60 * 1000;

/**
 * Attributes shared by some marketing cookies we write from the browser
 */
export const marketingCookieAttributes = (apexDomain: string) => ({
  expires: new Date(Date.now() + NINETY_DAYS_MS),
  domain: apexDomain,
  secure: true
});
